import { Box } from '@material-ui/core'
import cx from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RuleInfo } from '../../../api/types'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import EntityInfo from '../../../components/popups/entity-info/EntityInfo'
import CheckedIcon from '../../../shared/icons/checked_icon'
import InfoIconCD from '../../../shared/icons/info_icon_CD'
import UncheckedIcon from '../../../shared/icons/unchecked_icon'
import AppContext from '../../context'
import buildStyles from './styles'

const RulesView = () => {
  const { state } = useContext(AppContext)

  const [requiredRules, setRequiredRules] = useState<string[]>([])
  const [showedRule, setShowedRule] = useState<RuleInfo | null>(null)

  const navigate = useNavigate()

  useEffect(() => {
    setRequiredRules(
      state.rules
        .filter((rule: RuleInfo) => rule.isRequired)
        .map((rule) => rule.id)
    )
  }, [state.rules])

  const isChecked = (index: string) => {
    return !requiredRules.find((id) => id === index)
  }

  const handleCheckboxClick = (index: string) => {
    const checked = !requiredRules.find((id) => id === index)
    if (checked) {
      setRequiredRules([...requiredRules, index])
    } else {
      setRequiredRules([...requiredRules.filter((id) => id !== index)])
    }
  }

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  const enabledButton = requiredRules.length === 0
  return (
    <>
      {state.selectedGoal && state.selectedOrganization && (
        <HeaderInfo
          title="Regulamin"
          arrowedTitle={state.selectedGoal.title}
          orgName={state.selectedOrganization.name}
          altText={state.amount?.txt}
          addedSmallPadding={true}
        />
      )}
      <Box
        display="flex"
        width="100%"
        alignItems="center"
        flexDirection="column"
        padding="10px"
        className={styles.container}
      >
        <div className={styles.bottomText}>
          Do dokonania transakcji wymagana jest akceptacja regulaminu.
        </div>
        <div className={styles.bottomText}>
          W przeciwnym razie transakcja zostanie anulowana.
        </div>

        {state.rules && (
          <div className={styles.body}>
            <div className={styles.content}>
              {state.rules.map((rule, index) => {
                return (
                  <Box
                    display="flex"
                    alignItems="center"
                    key={index}
                    className={styles.rule}
                    onClick={() => handleCheckboxClick(rule.id)}
                  >
                    {rule.isRequired && (
                      <div className={styles.checkbox}>
                        {isChecked(rule.id) ? (
                          <CheckedIcon />
                        ) : (
                          <UncheckedIcon />
                        )}
                      </div>
                    )}
                    <div>{isChecked(rule.id)}</div>
                    <div className={styles.ruleTitle}>{rule.title}</div>

                    <div
                      className={styles.showIcon}
                      onClick={(event: React.MouseEvent<HTMLElement>) => {
                        event.stopPropagation()
                        setShowedRule(rule)
                      }}
                    >
                      <InfoIconCD />
                    </div>
                  </Box>
                )
              })}
            </div>
          </div>
        )}

        <Box
          display="flex"
          width="100%"
          paddingTop="25px"
          justifyContent="center"
        >
          <div
            className={cx(
              styles.nextButton,
              !enabledButton ? styles.disabledButton : undefined
            )}
            onClick={() => {
              if (enabledButton) {
                navigate(
                  `/${state.locationConfig?.locationCode}/${state.selectedOrganization?.id}/${state.selectedGoal?.id}/potwierdzenie`
                )
              }
            }}
          >
            <div className={styles.nextButtonSpan}>Dalej</div>
          </div>
        </Box>
      </Box>

      {showedRule && (
        <EntityInfo
          title={showedRule.title}
          subtitle={showedRule.description}
          isOpen={!!showedRule}
          onClose={() => setShowedRule(null)}
          maxWidth="md"
          fullWidth
        />
      )}
    </>
  )
}

export default RulesView
